import PropTypes from 'prop-types'
import React from 'react'

import DynamicImage from 'components/DynamicImage'

import { Wrapper } from './styles'

const BHowFirstEuroBox = ({ path }) => (
  <Wrapper>
    <DynamicImage
      image={`${path}/biome-left-new`}
      imageSizes={{ xs: 420, md: 650 }}
      imageType="png"
      fitOption="contain"
      alt={'Microbiome box'}
    />
  </Wrapper>
)

BHowFirstEuroBox.propTypes = {
  path: PropTypes.string.isRequired,
}

export default BHowFirstEuroBox
